export default __webpack_public_path__ + "6b014fc31bd7a9fd973aaeeb01c3742a.png";